<template>
  <div class="orden-nueva-contenedor">

    <!-- ══ ENCABEZADO ══════════════════════════════════════════════════════════ -->
    <div class="pn-encabezado">
      <div class="pn-titulo">
        <button class="btn-volver" @click="$router.push('/taller/ordenes')">
          <i class="bi bi-arrow-left"></i>
        </button>
        <div>
          <h5 class="pn-titulo-texto">
            <i class="bi bi-tools me-2"></i>{{ modoEdicion ? 'Editar Orden de Taller' : 'Nueva Orden de Taller' }}
          </h5>
          <p class="pn-subtitulo">{{ modoEdicion ? 'Modifica los datos de la orden.' : 'Completa los datos del vehiculo y los repuestos utilizados.' }}</p>
        </div>
      </div>
      <div class="pn-acciones">
        <button class="btn-cancelar" @click="$router.push('/taller/ordenes')">
          <i class="bi bi-x-circle me-1"></i>Cancelar
        </button>
        <button
          class="btn-guardar"
          @click="guardar"
          :disabled="guardando || lineas.length === 0"
        >
          <span v-if="guardando" class="spinner-border spinner-border-sm me-1"></span>
          <i v-else class="bi bi-check-circle me-1"></i>
          {{ modoEdicion ? 'Guardar cambios' : 'Guardar orden' }}
        </button>
      </div>
    </div>

    <!-- ══ ALERTA ══════════════════════════════════════════════════════════════ -->
    <div v-if="alerta.mensaje" class="pn-alerta" :class="'pn-alerta--' + alerta.tipo">
      <i :class="{
        'bi bi-exclamation-triangle-fill': alerta.tipo === 'error',
        'bi bi-exclamation-circle-fill':   alerta.tipo === 'advertencia',
        'bi bi-check-circle-fill':         alerta.tipo === 'exito'
      }"></i>
      <span>{{ alerta.mensaje }}</span>
      <button class="pn-alerta-cerrar" @click="alerta.mensaje = ''">
        <i class="bi bi-x"></i>
      </button>
    </div>

    <!-- ══ CUERPO ══════════════════════════════════════════════════════════════ -->
    <div class="pn-cuerpo">

      <!-- ── Columna izquierda: Vehiculo + Cliente ── -->
      <div class="pn-columna-lateral">

        <!-- CARD: Datos del vehiculo -->
        <div class="pn-card">
          <div class="pn-card-cabecera">
            <i class="bi bi-bicycle me-2"></i>Datos del vehiculo
          </div>
          <div class="pn-card-cuerpo pn-form-grid">
            <div class="pn-campo pn-campo--full">
              <label class="pn-etiqueta">Nombre del propietario</label>
              <input type="text" v-model="vehiculo.propietario_nombre" class="pn-input" placeholder="Quien deja la moto">
            </div>
            <div class="pn-campo">
              <label class="pn-etiqueta">Telefono</label>
              <input type="text" v-model="vehiculo.propietario_telefono" class="pn-input">
            </div>
            <div class="pn-campo">
              <label class="pn-etiqueta">Placa</label>
              <input type="text" v-model="vehiculo.placa" class="pn-input">
            </div>
            <div class="pn-campo">
              <label class="pn-etiqueta">Marca</label>
              <input type="text" v-model="vehiculo.marca" class="pn-input">
            </div>
            <div class="pn-campo">
              <label class="pn-etiqueta">Modelo</label>
              <input type="text" v-model="vehiculo.modelo" class="pn-input">
            </div>
            <div class="pn-campo">
              <label class="pn-etiqueta">Color</label>
              <input type="text" v-model="vehiculo.color" class="pn-input">
            </div>
            <div class="pn-campo">
              <label class="pn-etiqueta">Año</label>
              <input type="text" v-model="vehiculo.anio" class="pn-input">
            </div>
            <div class="pn-campo pn-campo--full">
              <label class="pn-etiqueta">Kilometraje</label>
              <input type="text" v-model="vehiculo.kilometraje" class="pn-input">
            </div>
          </div>
        </div>

        <!-- CARD: Cliente a facturar (opcional) -->
        <div class="pn-card">
          <div class="pn-card-cabecera">
            <i class="bi bi-person-fill me-2"></i>Cliente a facturar
          </div>
          <div class="pn-card-cuerpo">
            <p class="pn-sin-resultados mb-2">
              <i class="bi bi-info-circle me-1"></i>Opcional aqui. Si no se elige, al facturar se pedira un cliente registrado o Consumidor Final.
            </p>

            <div v-if="!clienteSeleccionado">
              <label class="pn-etiqueta">Buscar por nombre o identificación</label>
              <div class="pn-busqueda-wrap">
                <i class="bi bi-search pn-busqueda-icono"></i>
                <input
                  v-model="busquedaCliente"
                  type="text"
                  class="pn-input pn-busqueda-input"
                  placeholder="Ej: Juan Pérez o 0912345678..."
                  @input="buscarClientes"
                  @blur="cerrarSugerenciasCliente"
                  autocomplete="off"
                />
                <span v-if="buscandoCliente" class="pn-spinner-inline">
                  <span class="spinner-border spinner-border-sm"></span>
                </span>
              </div>
              <ul v-if="sugerenciasCliente.length" class="pn-sugerencias">
                <li
                  v-for="c in sugerenciasCliente"
                  :key="c.id"
                  @mousedown.prevent="seleccionarCliente(c)"
                  class="pn-sugerencias-item"
                >
                  <span class="pn-sug-codigo">{{ c.identification_number }}</span>
                  <span class="pn-sug-nombre">{{ c.business_name }}</span>
                </li>
              </ul>
            </div>

            <div v-else>
              <label class="pn-etiqueta">Cliente seleccionado</label>
              <div class="d-flex align-items-center gap-2">
                <input type="text" class="form-control form-control-sm"
                  :value="clienteSeleccionado.identification_number + ' — ' + clienteSeleccionado.business_name"
                  readonly style="background:var(--secondary-bg-main);color:var(--text-primary);border-color:var(--border-main)" />
                <button class="btn btn-outline-danger btn-sm" @click="limpiarCliente" title="Quitar cliente">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- CARD: Observaciones -->
        <div class="pn-card">
          <div class="pn-card-cabecera">
            <i class="bi bi-sliders me-2"></i>Observaciones
          </div>
          <div class="pn-card-cuerpo">
            <textarea
              v-model="observaciones"
              class="pn-input pn-textarea"
              rows="3"
              placeholder="Diagnostico, trabajo a realizar, observaciones..."
            ></textarea>
          </div>
        </div>

      </div>

      <!-- ── Columna derecha: Repuestos ── -->
      <div class="pn-columna-principal">
        <div class="pn-card pn-card--expand">
          <div class="pn-card-cabecera">
            <span><i class="bi bi-box-seam me-2"></i>Repuestos</span>
          </div>
          <div class="pn-card-cuerpo">

            <!-- Buscador de productos -->
            <div class="pn-busqueda-producto-wrap">
              <div class="pn-busqueda-wrap">
                <i class="bi bi-search pn-busqueda-icono"></i>
                <input
                  ref="inputProducto"
                  v-model="busquedaProducto"
                  type="text"
                  class="pn-input pn-busqueda-input"
                  placeholder="Buscar repuesto por nombre, código principal o auxiliar..."
                  @input="onBusquedaProductoInput"
                  @keyup.enter="buscarProductoInmediato"
                  @blur="cerrarSugerenciasProducto"
                  autocomplete="off"
                />
                <span v-if="buscandoProducto" class="pn-spinner-inline">
                  <span class="spinner-border spinner-border-sm"></span>
                </span>
              </div>

              <ul v-if="sugerenciasProducto.length" class="pn-sugerencias pn-sugerencias--producto">
                <li
                  v-for="p in sugerenciasProducto"
                  :key="p.id"
                  @mousedown.prevent="agregarProducto(p)"
                  class="pn-sugerencias-item"
                  :class="{ 'pn-sug-sin-stock': p.tipo_producto !== 'servicio' && parseFloat(p.stock_total || 0) <= 0 }"
                >
                  <div class="pn-sug-producto-info">
                    <span class="pn-sug-codigo">{{ p.codigo_principal }}</span>
                    <span class="pn-sug-nombre">{{ p.nombre_producto }}</span>
                  </div>
                  <div class="pn-sug-producto-meta">
                    <span class="pn-sug-precio">$ {{ parseFloat(p.precio_unitario || 0).toFixed(2) }}</span>
                    <span
                      v-if="p.tipo_producto === 'servicio'"
                      class="pn-badge-stock pn-badge-stock--ok"
                    >
                      <i class="bi bi-tools me-1"></i>Servicio
                    </span>
                    <span
                      v-else
                      class="pn-badge-stock"
                      :class="{
                        'pn-badge-stock--ok':       parseFloat(p.stock_total || 0) > 0,
                        'pn-badge-stock--sin-stock': parseFloat(p.stock_total || 0) <= 0
                      }"
                    >
                      <i class="bi bi-boxes me-1"></i>
                      {{ parseFloat(p.stock_total || 0) <= 0 ? 'Sin stock' : 'Stock: ' + parseFloat(p.stock_total || 0).toFixed(0) }}
                    </span>
                  </div>
                </li>
              </ul>
            </div>

            <!-- Tabla de líneas -->
            <div v-if="lineas.length === 0" class="pn-vacio">
              <i class="bi bi-inbox pn-vacio-icono"></i>
              <p>Busca y agrega los repuestos usados en esta orden.</p>
            </div>

            <div v-else class="pn-tabla-wrap">
              <table class="pn-tabla">
                <thead>
                  <tr>
                    <th class="pn-col-desc">Repuesto</th>
                    <th class="pn-col-num pn-col-cant">Cant.</th>
                    <th class="pn-col-num pn-col-precio">P. Unit.</th>
                    <th class="pn-col-num pn-col-desc-val">Desc. $</th>
                    <th class="pn-col-num pn-col-iva">IVA %</th>
                    <th class="pn-col-num pn-col-total">Total</th>
                    <th class="pn-col-accion"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(linea, idx) in lineas"
                    :key="idx"
                    :class="{ 'pn-fila-stock-warn': linea.cantidad > linea.stock_disponible }"
                  >
                    <td class="pn-col-desc">
                      <div class="pn-desc-wrap">
                        <input type="text" class="pn-input pn-input--sm" v-model="linea.descripcion" readonly />
                        <span v-if="linea.codigo" class="pn-codigo-badge">{{ linea.codigo }}</span>
                        <span v-if="linea.tipo_producto === 'servicio'" class="pn-stock-inline pn-stock-inline--ok">
                          Servicio
                        </span>
                        <span
                          v-else
                          class="pn-stock-inline"
                          :class="{
                            'pn-stock-inline--ok':   linea.stock_disponible > 0,
                            'pn-stock-inline--warn': linea.stock_disponible <= 0
                          }"
                        >
                          Disponible: {{ parseFloat(linea.stock_disponible || 0).toFixed(0) }}
                        </span>
                      </div>
                    </td>

                    <td class="pn-col-num">
                      <input
                        type="number"
                        class="pn-input pn-input--sm pn-input--right"
                        :class="{ 'pn-input--warn': linea.cantidad > linea.stock_disponible }"
                        v-model.number="linea.cantidad"
                        min="1"
                        step="1"
                        :max="linea.tipo_producto === 'servicio' ? null : linea.stock_disponible"
                        @input="ajustarCantidad(linea)"
                      />
                    </td>

                    <td class="pn-col-num">
                      <input
                        type="number"
                        class="pn-input pn-input--sm pn-input--right"
                        v-model.number="linea.precio_unitario"
                        min="0"
                        step="0.0001"
                        @input="calcularLinea(linea)"
                      />
                    </td>

                    <td class="pn-col-num">
                      <input
                        type="number"
                        class="pn-input pn-input--sm pn-input--right"
                        v-model.number="linea.descuento"
                        min="0"
                        step="0.01"
                        @input="calcularLinea(linea)"
                      />
                    </td>

                    <td class="pn-col-num">
                      <select class="pn-select pn-select--sm" v-model.number="linea.porcentaje_iva" @change="calcularLinea(linea)">
                        <option :value="0">0%</option>
                        <option :value="5">5%</option>
                        <option :value="15">15%</option>
                      </select>
                    </td>

                    <td class="pn-col-num pn-total-linea">
                      $ {{ parseFloat(linea.total_detalle || 0).toFixed(2) }}
                    </td>

                    <td class="pn-col-accion">
                      <button class="pn-btn-eliminar" @click="eliminarLinea(idx)" title="Quitar repuesto">
                        <i class="bi bi-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div v-if="lineasConStockExcedido > 0" class="pn-aviso-stock">
                <i class="bi bi-exclamation-triangle-fill me-2"></i>
                {{ lineasConStockExcedido }} repuesto(s) superan el stock disponible. No es posible guardar la orden hasta corregirlas.
              </div>
            </div>

          </div>
        </div>

        <!-- CARD: Resumen económico -->
        <div class="pn-card pn-card-resumen-principal">
          <div class="pn-card-cuerpo">
            <div class="row justify-content-end">
              <div class="col-md-4 small" style="color:var(--text-primary)">
                <div class="d-flex justify-content-between py-1 border-bottom">
                  <span>Subtotal</span><strong>$ {{ subtotal.toFixed(2) }}</strong>
                </div>
                <div v-if="descuentoTotal > 0" class="d-flex justify-content-between py-1 border-bottom">
                  <span>Descuento</span><strong class="text-danger">- $ {{ descuentoTotal.toFixed(2) }}</strong>
                </div>
                <template v-for="g in gruposIva" :key="g.porcentaje">
                  <div class="d-flex justify-content-between py-1 border-bottom" style="font-size:.8rem;color:var(--text-muted)">
                    <span>Base {{ g.porcentaje }}%</span><span>$ {{ g.base.toFixed(2) }}</span>
                  </div>
                  <div class="d-flex justify-content-between py-1 border-bottom">
                    <span>IVA {{ g.porcentaje }}%</span><strong>$ {{ g.iva.toFixed(2) }}</strong>
                  </div>
                </template>
                <div class="d-flex justify-content-between py-1">
                  <span class="fw-bold" style="color:var(--primary-main)">TOTAL</span>
                  <strong style="color:var(--primary-main);font-size:1.1rem">$ {{ total.toFixed(2) }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import api from '@/services/api'
import { ordenTallerService } from '@/services/ordenTallerService'
import notificaciones from '@/services/notificationService.js'

export default {
  name: 'ClientTallerOrdenNueva',

  data() {
    return {
      guardando: false,
      alerta: { mensaje: '', tipo: 'error' },

      modoEdicion: false,
      ordenId:     null,

      // Vehiculo
      vehiculo: {
        propietario_nombre:   '',
        propietario_telefono: '',
        placa:                '',
        marca:                '',
        modelo:               '',
        color:                '',
        anio:                 '',
        kilometraje:          ''
      },
      observaciones: '',

      // Cliente (opcional)
      busquedaCliente:        '',
      sugerenciasCliente:     [],
      buscandoCliente:        false,
      busquedaClienteTimeout: null,
      clienteSeleccionado:    null,

      // Repuestos
      busquedaProducto:        '',
      sugerenciasProducto:     [],
      buscandoProducto:        false,
      busquedaProductoTimeout: null,
      lineas:                  []
    }
  },

  async mounted() {
    const id = this.$route.params.id
    if (id) {
      this.modoEdicion = true
      this.ordenId     = parseInt(id)
      await this._cargarOrdenParaEditar(this.ordenId)
    }
  },

  computed: {
    subtotal() {
      return this.lineas.reduce((acc, l) => acc + parseFloat(l.subtotal || 0), 0)
    },
    totalIva() {
      return this.lineas.reduce((acc, l) => acc + parseFloat(l.iva || 0), 0)
    },
    descuentoTotal() {
      return this.lineas.reduce((acc, l) => acc + parseFloat(l.descuento || 0) * parseFloat(l.cantidad || 0), 0)
    },
    total() {
      return this.subtotal + this.totalIva
    },
    lineasConStockExcedido() {
      return this.lineas.filter(l => l.cantidad > l.stock_disponible).length
    },
    gruposIva() {
      const grupos = {}
      for (const l of this.lineas) {
        const piva = parseFloat(l.porcentaje_iva || 0)
        const key  = piva.toFixed(2)
        if (!grupos[key]) grupos[key] = { porcentaje: piva, base: 0, iva: 0 }
        grupos[key].base += parseFloat(l.subtotal || 0)
        grupos[key].iva  += parseFloat(l.iva     || 0)
      }
      return Object.values(grupos)
        .map(g => ({
          ...g,
          base: Math.round(g.base * 100) / 100,
          iva:  Math.round(g.iva  * 100) / 100,
        }))
        .sort((a, b) => a.porcentaje - b.porcentaje)
    },
  },

  methods: {
    async _cargarOrdenParaEditar(id) {
      try {
        const res   = await ordenTallerService.obtener(id)
        const orden = res.data.data
        if (!orden) { this.alerta = { mensaje: 'Orden no encontrada.', tipo: 'error' }; return }

        if (orden.cliente_id) {
          this.clienteSeleccionado = {
            id:                    orden.cliente_id,
            business_name:         orden.cliente_nombre,
            identification_number: orden.cliente_codigo,
          }
          this.busquedaCliente = orden.cliente_codigo + ' — ' + orden.cliente_nombre
        }

        this.vehiculo = {
          propietario_nombre:   orden.propietario_nombre   || '',
          propietario_telefono: orden.propietario_telefono || '',
          placa:                orden.placa                || '',
          marca:                orden.marca                || '',
          modelo:               orden.modelo               || '',
          color:                orden.color                || '',
          anio:                 orden.anio                 || '',
          kilometraje:          orden.kilometraje          || ''
        }
        this.observaciones = orden.observaciones || ''

        this.lineas = (orden.items || []).map(item => {
          const esServicio = item.tipo_producto === 'servicio'
          const l = {
            producto_id:      item.producto_id || null,
            descripcion:      item.producto_nombre || '',
            codigo:           item.producto_codigo || '',
            tipo_producto:    item.tipo_producto || 'bien',
            stock_disponible: esServicio ? Infinity : parseFloat(item.stock_disponible || 0),
            cantidad:         parseFloat(item.cantidad || 1),
            precio_unitario:  parseFloat(item.precio_unitario || 0),
            descuento:        parseFloat(item.descuento || 0),
            porcentaje_iva:   parseFloat(item.porcentaje_iva || 0),
            subtotal:         0,
            iva:              0,
            total_detalle:    0,
          }
          this.calcularLinea(l)
          return l
        })
      } catch {
        this.alerta = { mensaje: 'Error al cargar la orden para editar.', tipo: 'error' }
      }
    },

    // ── Cliente ───────────────────────────────────────────────
    buscarClientes() {
      if (this.clienteSeleccionado) this.clienteSeleccionado = null
      clearTimeout(this.busquedaClienteTimeout)
      const q = this.busquedaCliente.trim()
      if (q.length < 2) { this.sugerenciasCliente = []; return }
      this.buscandoCliente = true
      this.busquedaClienteTimeout = setTimeout(async () => {
        try {
          const resp = await api.get('/clientes/autocompletar', { params: { q, limit: 10 } })
          this.sugerenciasCliente = Array.isArray(resp.data?.data) ? resp.data.data : []
        } catch { /* silencioso */ }
        finally { this.buscandoCliente = false }
      }, 350)
    },

    cerrarSugerenciasCliente() {
      setTimeout(() => { this.sugerenciasCliente = [] }, 200)
    },

    seleccionarCliente(c) {
      this.clienteSeleccionado = c
      this.busquedaCliente     = c.identification_number + ' — ' + c.business_name
      this.sugerenciasCliente  = []
    },

    limpiarCliente() {
      this.clienteSeleccionado = null
      this.busquedaCliente     = ''
    },

    // ── Repuestos ─────────────────────────────────────────────
    buscarProductoInmediato() {
      clearTimeout(this.busquedaProductoTimeout)
      const q = this.busquedaProducto.trim()
      if (q.length < 1) { this.sugerenciasProducto = []; return }
      this.buscandoProducto = true
      api.get('/productos', { params: { filtros: JSON.stringify({ busqueda: q }), limit: 15, offset: 0 } })
        .then(res => {
          const lista = res.data?.data?.productos || []
          const qUp = q.toUpperCase()
          const exacto = lista.find(p =>
            (p.codigo_principal || '').toUpperCase() === qUp ||
            (p.codigo_auxiliar  || '').toUpperCase() === qUp
          )
          if (exacto) { this.agregarProducto(exacto) }
          else { this.sugerenciasProducto = lista }
        })
        .catch(() => {})
        .finally(() => { this.buscandoProducto = false })
    },

    onBusquedaProductoInput() {
      clearTimeout(this.busquedaProductoTimeout)
      const q = this.busquedaProducto.trim()
      if (q.length < 2) { this.sugerenciasProducto = []; return }
      this.buscandoProducto = true
      this.busquedaProductoTimeout = setTimeout(async () => {
        try {
          const res = await api.get('/productos', {
            params: { filtros: JSON.stringify({ busqueda: q }), limit: 15, offset: 0 }
          })
          this.sugerenciasProducto = res.data?.data?.productos || []
        } catch { /* silencioso */ }
        finally { this.buscandoProducto = false }
      }, 350)
    },

    cerrarSugerenciasProducto() {
      setTimeout(() => { this.sugerenciasProducto = [] }, 200)
    },

    async agregarProducto(producto) {
      this.sugerenciasProducto = []
      this.busquedaProducto    = ''

      const esServicio       = producto.tipo_producto === 'servicio'
      const stockDisponible  = parseFloat(producto.stock_total || 0)

      if (!esServicio && stockDisponible <= 0) {
        this.alerta = {
          mensaje: `"${producto.nombre_producto}" no tiene stock disponible. No se puede agregar a la orden.`,
          tipo:    'error'
        }
        return
      }

      const existente = this.lineas.find(l => l.producto_id === producto.id)
      if (existente) {
        this.ajustarCantidad(existente, existente.cantidad + 1)
        return
      }

      let precio = parseFloat(producto.precio_unitario || 0)
      let iva    = parseFloat(producto.tarifa_impuesto || 0)

      try {
        const resp = await api.get('/productos/' + producto.id + '/precios')
        const precios = resp.data?.data || []
        const precio1 = precios.find(x => x.tipo_precio === 'Precio1') || precios[0]
        if (precio1) precio = parseFloat(precio1.precio)
      } catch { /* usar precio_unitario del catálogo */ }

      const linea = {
        producto_id:      producto.id,
        descripcion:      producto.nombre_producto || '',
        codigo:           producto.codigo_principal || '',
        tipo_producto:    producto.tipo_producto || 'bien',
        stock_disponible: esServicio ? Infinity : stockDisponible,
        cantidad:         1,
        precio_unitario:  precio,
        descuento:        0,
        porcentaje_iva:   iva,
        subtotal:         0,
        iva:              0,
        total_detalle:    0
      }
      this.calcularLinea(linea)
      this.lineas.push(linea)
    },

    eliminarLinea(idx) {
      this.lineas.splice(idx, 1)
    },

    calcularLinea(linea) {
      const cant   = parseFloat(linea.cantidad        || 0)
      const precio = parseFloat(linea.precio_unitario || 0)
      const desc   = parseFloat(linea.descuento       || 0)
      const piva   = parseFloat(linea.porcentaje_iva  || 0)

      const sub             = Math.max(0, (precio - desc) * cant)
      linea.subtotal        = parseFloat(sub.toFixed(4))
      linea.iva             = parseFloat((linea.subtotal * piva / 100).toFixed(4))
      linea.total_detalle   = parseFloat((linea.subtotal + linea.iva).toFixed(4))
    },

    ajustarCantidad(linea, forzarCantidad = null) {
      linea.cantidad = Math.max(1, Math.floor(forzarCantidad ?? linea.cantidad ?? 1))

      const maxStock = Math.floor(parseFloat(linea.stock_disponible || 0))
      if (linea.cantidad > maxStock) {
        linea.cantidad = maxStock
        this.alerta = {
          mensaje: `Stock máximo alcanzado para "${linea.descripcion}". Solo hay ${maxStock} unidad(es) disponible(s).`,
          tipo:    'advertencia'
        }
      }

      this.calcularLinea(linea)
    },

    // ── Guardar ───────────────────────────────────────────────
    async guardar() {
      this.alerta.mensaje = ''

      if (this.lineas.length === 0) {
        this.alerta = { mensaje: 'Agrega al menos un repuesto a la orden.', tipo: 'error' }
        return
      }

      const lineaSinStock = this.lineas.find(l => l.cantidad > l.stock_disponible)
      if (lineaSinStock) {
        this.alerta = {
          mensaje: `Stock insuficiente para "${lineaSinStock.descripcion}". Disponible: ${parseFloat(lineaSinStock.stock_disponible || 0).toFixed(0)}, solicitado: ${lineaSinStock.cantidad}.`,
          tipo:    'error'
        }
        return
      }

      this.guardando = true

      const detalles = this.lineas.map(l => ({
        producto_id:      l.producto_id,
        descripcion:      l.descripcion,
        codigo_principal: l.codigo || null,
        cantidad:         l.cantidad,
        precio_unitario:  l.precio_unitario,
        descuento:        l.descuento,
        subtotal:         l.subtotal,
        porcentaje_iva:   l.porcentaje_iva,
        iva:              l.iva,
        total_detalle:    l.total_detalle
      }))

      const payload = {
        cliente_id:    this.clienteSeleccionado ? this.clienteSeleccionado.id : null,
        observaciones: this.observaciones || null,
        subtotal:      this.subtotal,
        iva:           this.totalIva,
        descuento_total: this.descuentoTotal,
        total:         this.total,
        detalles,
        ...this.vehiculo
      }

      try {
        if (this.modoEdicion) {
          await ordenTallerService.actualizar(this.ordenId, payload)
          notificaciones.success('Orden actualizada correctamente.')
        } else {
          await ordenTallerService.crear(payload)
          notificaciones.success('Orden creada correctamente.')
        }
        this.$router.push('/taller/ordenes')
      } catch (e) {
        this.alerta = {
          mensaje: e?.response?.data?.error || 'Error al guardar la orden.',
          tipo:    'error'
        }
      } finally {
        this.guardando = false
      }
    }
  }
}
</script>

<style scoped>
.orden-nueva-contenedor {
  padding: 1.25rem;
  color: var(--text-primary);
  min-height: 100%;
}

.pn-encabezado {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.25rem;
  flex-wrap: wrap;
}
.pn-titulo { display: flex; align-items: center; gap: .75rem; }
.pn-titulo-texto { margin: 0; font-size: 1.1rem; font-weight: 600; color: var(--text-primary); }
.pn-subtitulo { margin: .1rem 0 0; font-size: .8rem; color: var(--text-secondary); }
.pn-acciones { display: flex; gap: .5rem; align-items: center; flex-wrap: wrap; }

.btn-volver {
  display: inline-flex; align-items: center; justify-content: center;
  width: 2.1rem; height: 2.1rem; border-radius: .375rem;
  border: 1px solid var(--border-main); background: transparent;
  color: var(--text-secondary); cursor: pointer; transition: background .15s, color .15s;
}
.btn-volver:hover { background: var(--border-main); color: var(--text-primary); }

.btn-cancelar {
  padding: .4rem .9rem; font-size: .82rem; border-radius: .375rem;
  border: 1px solid var(--border-main); background: transparent;
  color: var(--text-secondary); cursor: pointer; transition: background .15s, color .15s;
}
.btn-cancelar:hover { background: var(--border-main); color: var(--text-primary); }

.btn-guardar {
  padding: .45rem 1.1rem; font-size: .85rem; font-weight: 600; border-radius: .375rem;
  border: none; background: var(--primary-main); color: #fff; cursor: pointer;
  display: inline-flex; align-items: center; transition: background .15s, opacity .15s;
}
.btn-guardar:hover:not(:disabled) { background: var(--primary-hover); }
.btn-guardar:disabled { opacity: .55; cursor: not-allowed; }

.pn-alerta {
  display: flex; align-items: center; gap: .6rem; padding: .65rem 1rem;
  border-radius: .5rem; margin-bottom: 1rem; font-size: .85rem; border: 1px solid transparent;
}
.pn-alerta--error { background: rgba(var(--accent-danger-rgb, 220,53,69), .1); border-color: var(--accent-danger); color: var(--accent-danger); }
.pn-alerta--advertencia { background: rgba(var(--accent-warning-rgb, 255,193,7), .12); border-color: var(--accent-warning); color: var(--accent-warning); }
.pn-alerta--exito { background: rgba(var(--accent-success-rgb, 25,135,84), .1); border-color: var(--accent-success); color: var(--accent-success); }
.pn-alerta-cerrar { margin-left: auto; background: none; border: none; cursor: pointer; color: inherit; opacity: .7; padding: 0 .2rem; }
.pn-alerta-cerrar:hover { opacity: 1; }

.pn-cuerpo { display: grid; grid-template-columns: 320px 1fr; gap: 1.25rem; align-items: start; }
@media (max-width: 900px) { .pn-cuerpo { grid-template-columns: 1fr; } }

.pn-columna-lateral { display: flex; flex-direction: column; gap: 1rem; }
.pn-columna-principal { display: flex; flex-direction: column; }

.pn-card { background: var(--secondary-bg-main); border: 1px solid var(--border-main); border-radius: .5rem; box-shadow: var(--shadow-sm); overflow: visible; }
.pn-card--expand { flex: 1; }
.pn-card-cabecera { display: flex; align-items: center; justify-content: space-between; padding: .55rem .9rem; background: var(--primary-main); color: #fff; font-size: .82rem; font-weight: 600; border-radius: .5rem .5rem 0 0; }
.pn-card-cuerpo { padding: .9rem; }

.pn-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: .75rem; }
.pn-campo { display: flex; flex-direction: column; gap: .25rem; }
.pn-campo--full { grid-column: 1 / -1; }
.pn-etiqueta { font-size: .78rem; color: var(--text-secondary); font-weight: 500; }
.pn-requerido { color: var(--accent-danger); }

.pn-input { background: var(--bg-main); color: var(--text-primary); border: 1px solid var(--border-main); border-radius: .375rem; padding: .4rem .6rem; font-size: .84rem; width: 100%; transition: border-color .15s; outline: none; }
.pn-input:focus { border-color: var(--border-focus); }
.pn-input--sm { padding: .28rem .5rem; font-size: .81rem; }
.pn-input--right { text-align: right; }
.pn-input--warn { border-color: var(--accent-warning) !important; }

.pn-select { background: var(--bg-main); color: var(--text-primary); border: 1px solid var(--border-main); border-radius: .375rem; padding: .4rem .6rem; font-size: .84rem; width: 100%; outline: none; transition: border-color .15s; }
.pn-select:focus { border-color: var(--border-focus); }
.pn-select--sm { padding: .28rem .5rem; font-size: .81rem; }

.pn-textarea { resize: vertical; min-height: 72px; }

.pn-busqueda-wrap { position: relative; display: flex; align-items: center; }
.pn-busqueda-icono { position: absolute; left: .65rem; color: var(--text-muted); font-size: .85rem; pointer-events: none; }
.pn-busqueda-input { padding-left: 2rem; padding-right: 2rem; }
.pn-spinner-inline { position: absolute; right: .6rem; color: var(--text-muted); }

.pn-busqueda-producto-wrap { position: relative; margin-bottom: 1rem; }
.pn-sugerencias {
  list-style: none; margin: 0; padding: .25rem 0; position: absolute;
  top: calc(100% + 2px); left: 0; right: 0; background: var(--secondary-bg-main);
  border: 1px solid var(--border-main); border-radius: .4rem; box-shadow: var(--shadow-md);
  z-index: 1050; max-height: 260px; overflow-y: auto;
}
.pn-sugerencias-item { display: flex; align-items: center; justify-content: space-between; gap: .5rem; padding: .45rem .75rem; cursor: pointer; font-size: .83rem; color: var(--text-primary); border-radius: .25rem; transition: background .12s; }
.pn-sugerencias-item:hover { background: var(--bg-main); }
.pn-sug-sin-stock { opacity: .55; cursor: not-allowed; }
.pn-sug-sin-stock:hover { background: transparent; }
.pn-sug-codigo { font-weight: 600; color: var(--primary-main); font-size: .78rem; margin-right: .3rem; }
.pn-sug-nombre { color: var(--text-primary); flex: 1; }
.pn-sug-producto-info { display: flex; align-items: baseline; gap: .3rem; flex: 1; min-width: 0; overflow: hidden; }
.pn-sug-producto-meta { display: flex; align-items: center; gap: .5rem; flex-shrink: 0; }
.pn-sug-precio { font-size: .78rem; color: var(--text-secondary); white-space: nowrap; }

.pn-badge-stock { font-size: .72rem; padding: .1rem .45rem; border-radius: 999px; font-weight: 500; white-space: nowrap; }
.pn-badge-stock--ok { background: rgba(25,135,84,.15); color: var(--accent-success); }
.pn-badge-stock--sin-stock { background: rgba(220,53,69,.13); color: var(--accent-danger); }

.pn-sin-resultados { margin-top: .5rem; font-size: .8rem; color: var(--text-muted); }

.pn-card-resumen-principal { margin-top: 1rem; }

.pn-vacio { text-align: center; padding: 2.5rem 1rem; color: var(--text-muted); }
.pn-vacio-icono { font-size: 2rem; display: block; margin-bottom: .5rem; }

.pn-tabla-wrap { overflow-x: auto; }
.pn-tabla { width: 100%; border-collapse: collapse; font-size: .82rem; }
.pn-tabla thead tr { background: var(--bg-main); }
.pn-tabla th { padding: .5rem .6rem; text-align: left; color: var(--text-secondary); font-weight: 600; font-size: .78rem; border-bottom: 1px solid var(--border-main); white-space: nowrap; }
.pn-tabla td { padding: .4rem .5rem; border-bottom: 1px solid var(--border-main); vertical-align: middle; color: var(--text-primary); }
.pn-tabla tbody tr:last-child td { border-bottom: none; }
.pn-tabla tbody tr:hover { background: var(--bg-main); }
.pn-fila-stock-warn { background: rgba(255,193,7,.07) !important; }

.pn-col-desc { min-width: 200px; }
.pn-col-num { text-align: right; white-space: nowrap; }
.pn-col-cant { width: 80px; }
.pn-col-precio { width: 110px; }
.pn-col-desc-val { width: 90px; }
.pn-col-iva { width: 80px; }
.pn-col-total { width: 100px; }
.pn-col-accion { width: 40px; text-align: center; }

.pn-desc-wrap { display: flex; flex-direction: column; gap: .2rem; }
.pn-codigo-badge { font-size: .72rem; color: var(--text-muted); font-family: monospace; }
.pn-stock-inline { font-size: .71rem; font-weight: 500; padding: .05rem .3rem; border-radius: .2rem; }
.pn-stock-inline--ok { color: var(--accent-success); background: rgba(25,135,84,.1); }
.pn-stock-inline--warn { color: var(--accent-danger); background: rgba(220,53,69,.1); }

.pn-total-linea { font-weight: 600; color: var(--accent-success); white-space: nowrap; }

.pn-btn-eliminar { background: none; border: 1px solid var(--border-main); border-radius: .3rem; padding: .2rem .4rem; color: var(--accent-danger); cursor: pointer; font-size: .82rem; transition: background .12s, border-color .12s; }
.pn-btn-eliminar:hover { background: rgba(220,53,69,.1); border-color: var(--accent-danger); }

.pn-aviso-stock { margin-top: .75rem; padding: .55rem .85rem; background: rgba(255,193,7,.12); border: 1px solid var(--accent-warning); border-radius: .4rem; font-size: .8rem; color: var(--accent-warning); }
</style>
